import React from 'react';

import cn from 'utils/cn';
import './AgencyEstimate.css';

const b = cn('agency-estimate');
const AgencyEstimate = function ({ estimate }: { estimate: number}) {
    return (
        <div className={b()}>
            { estimate }
        </div>
    );
};

export default AgencyEstimate;
